export default "__VITE_ASSET__qRsrE63Y__"